import React, { useState, useEffect } from 'react';
import Topbar from '../../admin/layouts/Topbar';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, TextField, InputAdornment, IconButton, Menu, Typography,
    Button,
} from '@mui/material';
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from '@mui/icons-material/Close';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import CircularProgress from '@mui/material/CircularProgress';
import instance from '../../utils/Api';
import { useGlobalContext } from '../../Contex'; // Adjust the path
import Addstudent from '../components/Add_student';
import LocationOnIcon from '@mui/icons-material/LocationOn';


const Student = () => {
    const { openDialog, setOpenDialog } = useGlobalContext();
    const { anchorEl, setAnchorEl } = useGlobalContext();   //filter
    const { loading, setLoading } = useGlobalContext();  // State to handle loading
    const { searchTerm, setSearchTerm } = useGlobalContext(); //search state
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [page, setPage] = useState(0);
    const rowsPerPage = 10; // Fixed rows per page
    const startIndex = (page) * rowsPerPage;  // Calculate the start and end index for pagination
    const [searchParams] = useSearchParams();
    const schoolId = searchParams.get('schoolId');
    const schoolname = searchParams.get('schoolname');
    const [students, setStudents] = useState([]);
    const [attendence, setAttendence] = useState([]);
    const [addstudents, setAddstudents] = useState(false);
    const today = new Date().toISOString().slice(0, 10); // Format: YYYY-MM-DD
    const [selectedDate, setSelectedDate] = useState(today);

    const handleChange = (event) => {
        setSelectedDate(event.target.value); // Update the state
    };
    //   //filter function open menu
    //   const handleClick1 = (event) => {
    //     setAnchorEl(event.currentTarget);
    // };
    // //filter function close menu
    // const handleClose1 = () => {
    //     setAnchorEl(null);
    // };


    // Handle search
    const filteredstudents = attendence.filter((student) => {
        const searchTermLower = (searchTerm).toLowerCase(); // Ensure searchTerm is always a string
        return (
            student?.driver_name?.toLowerCase().includes(searchTermLower) ||
            student?.driver_phone?.toLowerCase().includes(searchTermLower)
        );
    });

    //handle change
    const handleChangePage = (event, newPage) => {
        setPage(newPage); // Adjust to be 1-based
    };

    // Data slicing based on current page and rowsPerPage
    const paginatedStudents = filteredstudents.slice(page * rowsPerPage, (page + 1) * rowsPerPage);
    console.log(paginatedStudents);

    //fetch students
    const fetchAttendence = async (selectedDate) => {
        try {
            const response = await instance.get(`/Attendance/getAttendenceDayAll?date=${selectedDate}`);
            console.log(response.data.data);

            setAttendence(response.data.data);
        } catch (error) {
            console.error('Error fetching Schools:', error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAttendence(selectedDate);
        // setAddstudents(false) // Reset after fetching
        // setLoading(true);
    }, [selectedDate]);

    // Function to handle opening the popup for adding new admin
    const handleAddClick = () => {
        // setSelectedStudent(null);  // Clear selected admin (add new mode)
        setOpenDialog(true);  // Open the popup
    };

    return (
        <React.Fragment>
            <Topbar />
            {loading ? (
                <div className="loading">
                    <CircularProgress />
                </div>
            ) : (<section className='main'>
                <div className='employees-text inventory-backtn'>
                    <div>
                        <Typography variant='h5'>Attendance</Typography>
                        {/* <Typography variant='h6' >School Name: <span>{schoolname}</span></Typography> */}
                    </div>
                    {/* <div>
                        <Button style={{marginBottom:10, marginLeft:20}} onClick={() => navigate('/admin/schoollist')}><KeyboardBackspaceIcon />Back</Button>
                        <Button variant="outlined"  onClick={() => handleAddClick(schoolId)}>Add Student</Button>
                    </div> */}
                </div>
                <div className='employees-main'>
                    <div className='employees-content'>
                        <div className='search-options'>
                            <TextField
                                placeholder='Search'
                                type='search'
                                variant="outlined"
                                value={searchTerm}
                                onChange={(e) => { setSearchTerm(e.target.value); setPage(0) }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position='start'>
                                            <SearchIcon />
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </div>
                        <div className='pagination-options table-pagination'>
                            <div className='pagination-animation'></div>
                            <TablePagination
                                component="div"
                                count={filteredstudents?.length}
                                rowsPerPage={rowsPerPage}
                                page={page} // Adjust to be 0-based for MUI TablePagination
                                onPageChange={handleChangePage}
                                rowsPerPageOptions={[]}
                                labelDisplayedRows={({ from, to, count }) => (
                                    `${from} to ${to} of ${count !== -1 ? count : `more than ${to}`}`
                                )}
                            />
                            <div className='filter'>
                                <TextField
                                    type="date"
                                    label="Filter Date"
                                    value={selectedDate}
                                    onChange={handleChange}
                                    InputLabelProps={{
                                        shrink: true, // Ensures the label stays above the input when a value is present
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='employee-table'>
                        <TableContainer component={Paper}>
                            <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            <div className='employee-name'>
                                                S.NO
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <div className='employee-name'>
                                                Waste Picker Name
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <div className='employee-name'>
                                                Mobile Number
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <div className='employee-name' >
                                                Check In Location
                                            </div>
                                        </TableCell>
                                        {/* <TableCell>
                                            <div className='employee-name' >
                                                Check In longitude
                                            </div>
                                        </TableCell> */}
                                        <TableCell>
                                            <div className='employee-name' >
                                                Check In Address
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <div className='employee-name' >
                                                Check In
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <div className='employee-name' >
                                                Check Out Location
                                            </div>
                                        </TableCell>
                                        {/* <TableCell>
                                            <div className='employee-name' >
                                                Check Out longitude
                                            </div>
                                        </TableCell> */}
                                        <TableCell>
                                            <div className='employee-name' >
                                                Check Out Address
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <div className='employee-name' >
                                                Check Out
                                            </div>
                                        </TableCell>
                                        {/* <TableCell>
                                            <div className='employee-name' >
                                            Father Name
                                            </div>
                                        </TableCell> */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {paginatedStudents.length > 0 ? (
                                        paginatedStudents.map((attendence, index) => (
                                            <TableRow key={attendence._id}>
                                                <TableCell component="th" scope="row">
                                                    {startIndex + index + 1}
                                                </TableCell>
                                                <TableCell align='left'>{attendence?.driver_name}</TableCell>
                                                <TableCell align="left">{attendence?.driver_phone}</TableCell>
                                                <TableCell align="center"><LocationOnIcon style={{ cursor: 'pointer' }} onClick={() => {
                                                    window.open(`https://www.google.com/maps?q=${attendence?.check_in_location?.latitude},${attendence?.check_in_location?.longitude}`, '_blank');
                                                }} /></TableCell>
                                                {/* <TableCell align="left">{attendence?.check_in_location?.longitude}</TableCell> */}
                                                <TableCell align="left">{attendence?.check_in_location?.location}</TableCell>
                                                <TableCell align="left">{new Date(attendence?.check_in).toLocaleString()}</TableCell>
                                                <TableCell align="center">{attendence?.check_out_location?.latitude ? <LocationOnIcon style={{ cursor: 'pointer' }} onClick={() => {
                                                    window.open(`https://www.google.com/maps?q=${attendence?.check_out_location?.latitude},${attendence?.check_out_location?.longitude}`, '_blank');
                                                }} /> : "----"}</TableCell>
                                                {/* <TableCell align="left">{attendence?.check_out_location ? attendence?.check_out_location?.longitude : "----"}</TableCell> */}
                                                <TableCell align="left">{attendence?.check_out_location ? attendence?.check_out_location?.location : "----"}</TableCell>
                                                <TableCell align="left">{attendence?.check_out ? new Date(attendence?.check_out).toLocaleString() : '----'}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={12} align="center" >
                                                <Typography>No Data Found</Typography>
                                            </TableCell>
                                        </TableRow>
                                    )
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </section>
            )}
            <Addstudent openDialog={openDialog} setOpenDialog={setOpenDialog} setAddstudents={setAddstudents} schoolId={schoolId} />
        </React.Fragment>
    )
}

export default Student